import { Controller } from "@hotwired/stimulus"

// Conecta o Stimulus ao botão de compartilhamento
export default class extends Controller {
  share(event) {
    event.preventDefault(); // Evita recarregar a página caso esteja dentro de um <a>

    if (navigator.share) {
      navigator.share({
        title: "Confira esse vídeo no TikTok!",
        url: window.location.href
      })
      .then(() => console.log("Compartilhado com sucesso"))
      .catch((error) => console.log("Erro ao compartilhar", error));
    } else {
      alert("Seu navegador não suporta compartilhamento direto.");
    }
  }
}